<template>
  <div ref="lottieContainer" style="background-color: #fff; border-radius: 8x; margin-bottom: 8px; border-radius: 8px; padding-top: 8px;"></div>
</template>

<script>
import lottie from "lottie-web";

import animationDataHappy from "@/assets/lottiefiles/animation_happy.json";
import animationDataSad from "@/assets/lottiefiles/animation_sad.json";
import clickHand from "@/assets/lottiefiles/click_hand.json";
import animationPodcast from "@/assets/lottiefiles/podcast.json";
import animationPodcast2 from "@/assets/lottiefiles/podcast2.json";
import atividade from "@/assets/lottiefiles/atividade.json";

export default {
  props: ["sad", "happy", "hand", "podcast", "podcast2", "atividade"],

  mounted() {
    this.renderLottieAnimation();
  },

  methods: {
    renderLottieAnimation() {
      const container = this.$refs.lottieContainer;

      if (container) {
        const animationOptions = {
          container: container,
          animationData: this.animation,
          loop: true,
          autoplay: true,
        };

        this.anim = lottie.loadAnimation(animationOptions); // Save the animation instance
      }
    },
  },

  computed: {
    animation() {
      if (this.sad) {
        return animationDataSad;
      } else if (this.happy) {
        return animationDataHappy;
      } else if (this.hand) {
        return clickHand;
      } else if (this.atividade) {
        return atividade;
      } else if (this.podcast) {
        return animationPodcast
      } else if (this.podcast2){
        return animationPodcast2
      } else {
        // Caso nenhuma prop esteja definida, você pode retornar uma animação padrão ou `null`
        return null;
      }
    },
  },
};
</script>

<style>
</style>
